import React from 'react';
import { Div } from 'glamorous';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true, error, info });
        console.error(error);
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
    }

    render() {
        if (this.state.hasError) {
            return <Div css={{ background: "#fee", border: "1px solid #c00", margin: "1em", padding: "1em", "> h1": { color: "#c00", margin: "0.5em 0" } }}>
                <h1>{this.state.error.name}</h1>
                <p>{this.state.error.message}</p>
                <pre>{this.state.info.componentStack}</pre>
            </Div>
        }
        return this.props.children;
    }
}